import { Controller } from "stimulus";

export default class extends Controller {
  setPosition() {
    document.getElementById("user_review_lesson_position").value =
      this.data.get("position");
  }
}
